import { useEffect, useState } from "react";
import { Header } from "../../common/Header/Header.jsx";
import { SelectPerPage } from "../../common/Forms/Input/Input";
import { AllianceTable } from "../../common/Tables/Tables";
import { allianceTableheader } from "../../../assets/helpers/tables";
import {
  getProvidersEnum,
  allyStatusOptions,
} from "../../../assets/helpers/options";
import { businessAllyService } from "../../../services/businessAllyService.js";
import { enterpriseService } from "../../../services/enterpriseService.js";
import { notify } from "../../../assets/helpers/toast";
import { SearchInput } from "../../common/Forms/Input/Input";
import { useHistory } from "react-router-dom";
import { exists, filterParams } from "../../../assets/helpers/funciones";
import { BlockAllyModal, CreateAllyModal } from "../../common/Modals/Modals";
import "./Alliances.scss";
import { ActionButton } from "../../common/Buttons/Buttons.jsx";
import * as schemas from "../../../assets/schemas/schemas";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";

const itemsPerpage = [10, 25, 50, 100, 500];

export const Alliances = () => {
  const history = useHistory();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
    setValue,
  } = useForm({
    resolver: yupResolver(schemas.allianceSchema()),
    defaultValues: {
      isNew: false, // Initial value for firstName
    },
  });

  const [isLoading, setIsloading] = useState(false);
  const [newEnterprise, setNewEnterprise] = useState(false);
  const [openBlockModal, setOpenBlockModal] = useState({
    isOpen: false,
    allyData: {
      id: "",
      name: "",
      status: "",
    },
  });

  const [businessAllyTable, setBusinessAllyTable] = useState({
    limit: itemsPerpage[0],
    offset: 0, //Elementos que ya pasaron la pagina
    data: [],
    count: 0, //Cantidad de elementos
    page: 1,
    type: getProvidersEnum.CRANE,
    isInternal: false,
    isLoading: true,
  });

  const [enterpriseOptions, setEnterpriseOptions] = useState([]);

  const [createallyModal, setCreateAllyModal] = useState({
    show: false,
  });

  const createAlliance = handleSubmit(async (data) => {
    let dataToPost = { ...data };

    dataToPost.identification = dataToPost.identification.toString();
    delete dataToPost.isNew;

    if (!isLoading && !data.isNew) {
      setIsloading(true);
      createNewAlliance(dataToPost);
    }

    if (!isLoading && data.isNew) {
      setIsloading(true);
      createNewEnterprise(data);
    }
  });

  const createNewAlliance = (data) => {
    delete data.newEnterprise;
    businessAllyService
      .createBusinessAlly(filterParams(data))
      .then((response) => {
        if (response.status === 201) {
          notify(`Alianza creada`, "success");
          setIsloading(false);
          handleCreateAllyModal();
          getFleetLocation();
          getEnterprise();
        } else {
          notify(`${response.message}`, "error");
          setIsloading(false);
        }
      })
      .catch((error) => {
        setIsloading(false);
      });
  };

  const createNewEnterprise = (data) => {
    enterpriseService
      .createForAlliance(filterParams({ name: data.newEnterprise }))
      .then((response) => {
        if ([201, 200].includes(response.status)) {
          getEnterprise();
          let dataToPost = { ...data };
          delete dataToPost.newEnterprise;
          delete dataToPost.isNew;
          dataToPost.enterprise = response.data.enterprise._id;
          dataToPost.identification = dataToPost.identification.toString();
          createNewAlliance(dataToPost);
        } else {
          notify(`${response.message}`, "error");
          setIsloading(false);
        }
      })
      .catch((error) => {
        setIsloading(false);
      });
  };

  const selectitemsPerpage = (event) => {
    setBusinessAllyTable((prevState) => {
      return {
        ...prevState,
        page: 1,
        offset: 0,
        limit: parseInt(event.target.value),
      };
    });
  };

  const handlePageChange = (event, value) => {
    setBusinessAllyTable((prevState) => {
      return {
        ...prevState,
        page: value,
        offset: (value - 1) * businessAllyTable?.limit,
      };
    });
  };

  const getFleetLocation = () => {
    setBusinessAllyTable((prevState) => {
      return {
        ...prevState,
        isLoading: true,
      };
    });
    let params = {
      offset: businessAllyTable?.offset,
      limit: businessAllyTable?.limit,
      identification: businessAllyTable?.description,
    };

    businessAllyService
      .getBusinessAlly(filterParams(params))
      .then((response) => {
        if (response.status === 200) {
          setBusinessAllyTable((prevState) => {
            return {
              ...prevState,
              data: response?.data?.businessAlly,
              count: response?.data?.total,
              isLoading: false,
            };
          });
        } else {
          notify(`${response.message}` || "error", "error");
          setBusinessAllyTable((prevState) => {
            return {
              ...prevState,
              isLoading: false,
            };
          });
        }
      })
      .catch((error) => {
        setBusinessAllyTable((prevState) => {
          return {
            ...prevState,
            isLoading: false,
          };
        });
      });
    return true;
  };

  const getEnterprise = () => {
    enterpriseService.getFleetLocation().then((response) => {
      if (response.status === 200) {
        setEnterpriseOptions(response?.data?.enterprises);
      }
    });
  };

  const handleCreateAllyModal = (data) => {
    setCreateAllyModal((prevState) => {
      return {
        ...prevState,
        show: !prevState.show,
        data: data ? data : "",
      };
    });
    reset();
  };

  const handleSearchChange = (e) => {
    const { value } = e?.target;
    setBusinessAllyTable((prevState) => {
      return {
        ...prevState,
        description: value,
        page: 1,
        offset: 0,
      };
    });
    if (!value) {
      window.location.reload();
    }
  };

  const handleEdit = (e) => {
    history.push(`/providers/external/edit/${e?._id}`);
  };

  const handleBlockAlly = () => {
    setBusinessAllyTable((prevState) => {
      return {
        ...prevState,
        isLoading: true,
      };
    });
    let { id, status } = openBlockModal.allyData;

    status === "Activo" ? (status = "Bloqueado") : (status = "Activo");
    businessAllyService
      .updateBusinessAllyStatus(id, { status })
      .then((response) => {
        if (response.status === 200) {
          setOpenBlockModal((prevState) => {
            return {
              ...prevState,
              isOpen: false,
              allyData: {
                name: "",
                id: "",
                status: "",
              },
            };
          });
          if (response.data.enterprise.status === "Activo") {
            notify("Aliado Activado con éxito", "success");
          } else {
            notify("Aliado Bloqueado con éxito", "success");
          }
          getFleetLocation();
          setBusinessAllyTable((prevState) => {
            return {
              ...prevState,
              isLoading: false,
            };
          });
        } else {
          notify(`${response.message}` || "error", "error");
          setOpenBlockModal((prevState) => {
            return {
              ...prevState,
              isOpen: false,
              allyData: {
                name: "",
                id: "",
                status: "",
              },
            };
          });
          setBusinessAllyTable((prevState) => {
            return {
              ...prevState,
              isLoading: false,
            };
          });
        }
      })
      .catch((error) => {
        setOpenBlockModal((prevState) => {
          return {
            ...prevState,
            isOpen: false,
            allyData: {
              name: "",
              id: "",
              status: "",
            },
          };
        });
        setBusinessAllyTable((prevState) => {
          return {
            ...prevState,
            isLoading: false,
          };
        });
      });
    return true;
  };

  const handleShowModal = (ally) => {
    setOpenBlockModal((prevState) => {
      return {
        ...prevState,
        isOpen: true,
        allyData: {
          name: ally.name,
          id: ally.id,
          status: ally.status,
        },
      };
    });
  };

  useEffect(() => {
    getFleetLocation();
    getEnterprise();
  }, [
    businessAllyTable?.page,
    businessAllyTable?.offset,
    businessAllyTable?.limit,
    businessAllyTable?.type,
  ]);

  const modal = {
    onChange: { setNewEnterprise: setNewEnterprise },
    newEnterprise: newEnterprise,
    form: {
      register: register,
      errors: errors,
      options: {
        enterpriseOptions: enterpriseOptions,
        allyStatusOptions: allyStatusOptions,
      },
      cancel: handleCreateAllyModal,
      action: createAlliance,
      watch: watch,
      setValue: setValue,
    },
    ...createallyModal,
  };

  return (
    <>
      <CreateAllyModal modal={modal} />
      <BlockAllyModal
        data={openBlockModal.allyData}
        show={openBlockModal.isOpen}
        cancel={() => {
          setOpenBlockModal((prevState) => {
            return {
              ...prevState,
              isOpen: false,
            };
          });
        }}
        action={handleBlockAlly}
      />
      <Header />
      <div className="service-with-container container">
        <h1 className="title-component">
          Alianzas: {exists(businessAllyTable?.count)}
        </h1>
        <div className="breadcrumb-container">
          <div className="providers-buttons-container">
            <span></span>
          </div>
        </div>
        <div className="gray-line"></div>

        <div className="filter-button-container"></div>
        <br />
        <div className="breadcrumb-container">
          <div className="service-filter-buttons-container">
            <SelectPerPage
              label={"Registros por página"}
              options={itemsPerpage}
              value={businessAllyTable?.limit}
              onChange={selectitemsPerpage}
            />
            <SearchInput
              placeholder={"Busqueda"}
              width="120px"
              value={businessAllyTable?.description}
              onChange={handleSearchChange}
              searchAction={getFleetLocation}
            />
          </div>
          <ActionButton
            label={"Registrar nuevo aliado"}
            action={() => handleCreateAllyModal()}
          />
        </div>
        <AllianceTable
          showModal={openBlockModal}
          cancelModal={() => {
            setOpenBlockModal((prevState) => {
              return {
                ...prevState,
                isOpen: false,
              };
            });
          }}
          actionModal={handleBlockAlly}
          handleAction={handleShowModal}
          header={allianceTableheader}
          dataTable={businessAllyTable}
          handlePageChange={handlePageChange}
          edit={handleEdit}
          handleModal={handleCreateAllyModal}
        />
      </div>
    </>
  );
};
